import { combineReducers } from 'redux';
import cplist from './cplist';

export default combineReducers({
  cplist,
});
